import { requiredParam } from 'sdc-utilities';

export default (function (_ref) {
  var _ref$backend = _ref.backend,
      backend = _ref$backend === undefined ? requiredParam('backend') : _ref$backend,
      accessKey = _ref.accessKey;
  return {
    list: function list(spaceID) {
      return function () {
        return backend.get('locales/' + spaceID + (accessKey ? '?key=' + accessKey : ''));
      };
    }
  };
});